import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Forbidden() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: '#f5f5f5',
        flexDirection: 'column',
        gap: 2,
        p: 3
      }}
    >
      <Typography variant="h1" sx={{ fontSize: '8rem', fontWeight: 'bold', color: '#E50019' }}>
        403
      </Typography>
      
      <Typography variant="h4" gutterBottom>
        Access Denied
      </Typography>
      
      <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
        You do not have permission to access this page.
      </Typography>
      
      <Button 
        variant="contained" 
        onClick={() => navigate('/account')}
        sx={{ 
            backgroundColor: '#E50019',
            '&:hover': {
                backgroundColor: '#c40015'
            },
            px: 4,
            py: 1
        }}
      >
        Go to Account
      </Button>
    </Box>
  );
}

export default Forbidden;
